module.exports = __webpack_public_path__ + "img/dataMigrationAct.42611d3c.png";